import { render, staticRenderFns } from "./MultiPolTypeHelpList.vue?vue&type=template&id=3495b056&"
import script from "./MultiPolTypeHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiPolTypeHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports